import { Button } from "@tento-ui/components/button/button";
import { Toast } from "@tento-ui/components/toast/toast";
import { Storybook } from "@tento-ui/ui/storybook";
import { TimescaleModal } from "@tento-lona/sheets-ui/sheet/components/time-scale-modal.ts";

/** The storybook page for the time-scale picker, for a component gallery. */
export class TimescaleModalStoryBook extends Storybook.Default {
  title(): string {
    return "Time Scale Modal";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Default (Month selected)",
        render: () => {
          return TimescaleModal.makeWith("month", async (timescale) => {
            Toast.info(`Selected time scale: ${timescale}`);
            return null;
          });
        },
      },
      {
        title: "Year selected",
        render: () => {
          return TimescaleModal.makeWith("year", async (timescale) => {
            Toast.info(`Selected time scale: ${timescale}`);
            return null;
          });
        },
      },
      {
        title: "Week selected",
        render: () => {
          return TimescaleModal.makeWith("week", async (timescale) => {
            Toast.info(`Selected time scale: ${timescale}`);
            return null;
          });
        },
      },
      {
        title: "Day selected",
        render: () => {
          return TimescaleModal.makeWith("day", async (timescale) => {
            Toast.info(`Selected time scale: ${timescale}`);
            return null;
          });
        },
      },
      {
        title: "With Error",
        render: () => {
          return TimescaleModal.makeWith("month", async () => {
            return { error: "Cannot change time scale for this row" };
          });
        },
      },
      {
        title: "Show Modal Button",
        render: () => {
          return Button.makeWithLight("Open Time Scale Modal", {
            type: "primary",
            onClick: () => {
              TimescaleModal.makeWith("week", async (timescale) => {
                Toast.info(`Selected time scale: ${timescale}`);
                return null;
              }).reveal();
            },
          });
        },
      },
    ];
  }
}
